import styled from 'styled-components'
import { colors } from 'Common/constants'

export const CarouselDiv = styled.div`
    width: 245px;
    background-color: ${colors.main};
`